import { Directive, ElementRef, EventEmitter, HostListener, Output } from '@angular/core';
import { VldGroupDirective } from 'directives/vld-group/vld-group';

/**
 * Generated class for the VldButtonSkipDirective directive.
 *
 * See https://angular.io/api/core/Directive for more info on Angular
 * Directives.
 */
@Directive({
    selector: '[vld-button-skip]' // Attribute selector
    ,
    standalone: false
})
export class VldButtonSkipDirective {
  group: VldGroupDirective;

  originalVisibility: string;
  shown: boolean = true; // as in "our internal state"
  @Output() vldClickSkip: EventEmitter<any> = new EventEmitter(); /** Only sends clicked event if there are no errors. */

  constructor(private element: ElementRef) {}

  ngOnInit() {
    this.originalVisibility = this.element.nativeElement.style.visibility;
    // the template is assumed made visible state - otherwise we wouldn't know _which_ state to use for visible
    console.assert(this.originalVisibility != 'hidden' && this.originalVisibility != 'collapse');
  }

  showButton(show: boolean) {
    if (!show != !this.shown) {
      this.element.nativeElement.style.visibility = show ? this.originalVisibility : 'hidden';
      this.shown = !!show;
    }
  }

  @HostListener('click', ['$event'])
  clickEvent(event:Event) {
    this.group.onSkipClicked(event);
    this.vldClickSkip.emit();
    void this.group.progress.scrollIfNeededAsync(event.target as HTMLElement);
  }

}
